import React, {useEffect, useState} from "react";
import SunnhetAdferdStatistikk from "../components/SunnhetAdferdStatistikk";
import {
    getRyggIndeksHistorie,
    getHdIndeksHistorie,
    getMentalbeskrivelse,
    getSunnhetUndersoekelser,
    getAvkomRoentgenStatistikk,
    getBarnebarmRoentgenStatistikk,
    getRaseRoentgenStatistikk
} from "../api";
import {withRouter} from "react-router-dom";

const SunnhetAdferdStatistikkContainer = (props) => {
    const { id } = props.match.params;
    const hund = props.hund;

    const {hdIndekser, isHdIndekserLoading} = useFetchHdIndeksHistorie(hund.hundId, id);
    const {sunnhetUndersoekelser, isSunnhetUndersoekelserLoading} = useFetchSunnhetUndersoekelser(hund.hundId, id);
    const {uoffsielleSunnhetUndersoekelser, isUoffsielleSunnhetUndersoekelserLoading} = useFetchUoffsielleSunnhetUndersoekelser(hund.hundId, id);
    const {ryggIndekser, isRyggIndekserLoading} = useFetchRyggIndeksHistorie(hund.hundId, id);
    const {mentalbeskrivelse, isMentalbeskrivelseLoading} = useFetchMentalbeskriveles(hund.hundId, id);
    const {avkomRoentgenStatistikk, isAvkomRoentgenStatistikkLoading} = useFetchAvkomRoentgenStatistikk(hund.hundId, id);
    const {raseRoentgenStatistikk, isRaseRoentgenStatistikkLoading} = useFetchRaseRoentgenStatistikk(hund.hundId, id);
    const {barnebarnRoentgenStatistikk, isBarnebarnRoentgenStatistikkLoading} = useFetchBarnebarnRoentgenStatistikk(hund.hundId, id);


    return (

        <SunnhetAdferdStatistikk    hund={hund}

                                    roentgenUndersoekelser={sunnhetUndersoekelser[0]}
                                    oeyeEcvoUndersoekelser={sunnhetUndersoekelser[1]}
                                    oeyeDnaUndersoekelser={sunnhetUndersoekelser[2]}
                                    dnaUndersoekelser={sunnhetUndersoekelser[3]}
                                    oevrigeUndersoekelser={sunnhetUndersoekelser[4]}
                                    isSunnhetUndersoekelserLoading={isSunnhetUndersoekelserLoading}

                                    uoffsielleSunnhetUndersoekelser={uoffsielleSunnhetUndersoekelser}
                                    isUoffsielleSunnhetUndersoekelserLoading={isUoffsielleSunnhetUndersoekelserLoading}

                                    hdIndekser={hdIndekser}
                                    isHdIndekserLoading={isHdIndekserLoading}
                                    ryggIndekser={ryggIndekser}
                                    isRyggIndekserLoading={isRyggIndekserLoading}

                                    mentalbeskrivelse={mentalbeskrivelse}
                                    isMentalbeskrivelseLoading={isMentalbeskrivelseLoading}

                                    avkomRoentgenStatistikk={avkomRoentgenStatistikk}
                                    isAvkomRoentgenStatistikkLoading={isAvkomRoentgenStatistikkLoading}

                                    barnebarnRoentgenStatistikk={barnebarnRoentgenStatistikk}
                                    isBarnebarnRoentgenStatistikkLoading={isBarnebarnRoentgenStatistikkLoading}

                                    raseRoentgenStatistikk={raseRoentgenStatistikk}
                                    isRaseRoentgenStatistikkLoading={isRaseRoentgenStatistikkLoading}

        />
    );
};

const useFetchHdIndeksHistorie = (hundId, id) => {
    const [hdIndekser, setHdIndekser] = useState([]);
    const [isHdIndekserLoading, setIsHdIndekserLoading] = useState(false);

    useEffect(() => {
        let isMounted = true;
        const fetchData = () => {
            if (isMounted) {
                setIsHdIndekserLoading(true);
            }
            getHdIndeksHistorie(hundId, id)
                .then((data) => {
                    if (isMounted) {
                        setHdIndekser(data);
                        setIsHdIndekserLoading(false);
                    }
                })
                .catch((err)=> {
                    if (isMounted) {
                        setIsHdIndekserLoading(false);
                        setHdIndekser(null);
                    }

                });
        };
        fetchData();
        return () => {
            isMounted = false;
        };
    }, [hundId, id]);
    return { hdIndekser, isHdIndekserLoading };
};

const useFetchRyggIndeksHistorie = (hundId, id) => {
    const [ryggIndekser, setRyggIndekser] = useState([]);
    const [isRyggIndekserLoading, setIsRyggIndekserLoading] = useState(false);

    useEffect(() => {
        let isMounted = true;
        const fetchData = () => {
            if (isMounted) {
                setIsRyggIndekserLoading(true);
            }
            getRyggIndeksHistorie(hundId, id)
                .then((data) => {
                    if (isMounted) {
                        let indekser = [];
                        for (var i = 0; i < data.length; i++) {
                            indekser.push(data[i]);
                        }
                        setRyggIndekser(indekser);
                        setIsRyggIndekserLoading(false);
                    }
                })
                .catch((err)=> {
                    if (isMounted) {
                        setIsRyggIndekserLoading(false);
                        setRyggIndekser(null);
                    }
                });
        };
        fetchData();
        return () => {
            isMounted = false;
        };
    }, [hundId, id]);
    return { ryggIndekser, isRyggIndekserLoading };
};

const useFetchUoffsielleSunnhetUndersoekelser = (hundId, id) => {
    const [uoffsielleSunnhetUndersoekelser, setUoffsielleSunnhetUndersoekelser] = useState([]);
    const [isUoffsielleSunnhetUndersoekelserLoading, setIsUoffsielleSunnhetUndersoekelserLoading] = useState(false);

    useEffect(() => {
        let isMounted = true;
        const fetchData = () => {
            if (isMounted) {
                setIsUoffsielleSunnhetUndersoekelserLoading(true);
            }
            getSunnhetUndersoekelser(hundId, true, id)
                .then((data) => {
                    if (isMounted) {
                        setUoffsielleSunnhetUndersoekelser(data);
                        setIsUoffsielleSunnhetUndersoekelserLoading(false);
                    }
                })
                .catch((err)=> {
                    if (isMounted) {
                        setIsUoffsielleSunnhetUndersoekelserLoading(false);
                        console.log(err);
                        setUoffsielleSunnhetUndersoekelser(null);
                    }
                });
        };
        fetchData();
        return () => {
            isMounted = false;
        };
    }, [hundId, id]);
    return { uoffsielleSunnhetUndersoekelser, isUoffsielleSunnhetUndersoekelserLoading };
};

const useFetchSunnhetUndersoekelser = (hundId, id) => {
    const [sunnhetUndersoekelser, setSunnhetUndersoekelser] = useState([ [], [], [], [], [] ]);
    const [isSunnhetUndersoekelserLoading, setIsSunnhetUndersoekelserLoading] = useState(false);

    useEffect(() => {
        let isMounted = true;
        const fetchData = () => {
            if (isMounted) {
                setIsSunnhetUndersoekelserLoading(true);
            }
            getSunnhetUndersoekelser(hundId, false, id)
                .then((data) => {
                    if (isMounted) {
                        let roentgen = [];
                        let oeye = [];
                        let oeyeDna = [];
                        let dna = [];
                        let oevrige = [];
                        for (var i = 0; i < data.length; i++) {
                            const kategoriId = data[i].sunnhetKategoriId;
                            if (kategoriId === 5) {
                                roentgen.push(data[i]);
                            } else if (kategoriId === 1) {
                                oeye.push(data[i]);
                            } else if (kategoriId === 9) {
                                oeyeDna.push(data[i]);
                            } else if (kategoriId === 10) {
                                dna.push(data[i]);
                            } else if (kategoriId === 2 || kategoriId === 3
                                || kategoriId === 6 || kategoriId === 7) {
                                oevrige.push(data[i]);
                            }
                        }
                        setSunnhetUndersoekelser([roentgen, oeye, oeyeDna, dna, oevrige]);
                        setIsSunnhetUndersoekelserLoading(false);
                    }
                })
                .catch((err)=> {
                    if (isMounted) {
                        setIsSunnhetUndersoekelserLoading(false);
                        console.log(err);
                        setSunnhetUndersoekelser(null);
                    }
                });
        };
        fetchData();
        return () => {
            isMounted = false;
        };
    }, [hundId, id]);
    return { sunnhetUndersoekelser, isSunnhetUndersoekelserLoading };
};

const useFetchMentalbeskriveles = (hundId, id) => {
    const [mentalbeskrivelse, setMentalbeskrivelse] = useState(null);
    const [isMentalbeskrivelseLoading, setIsMentalbeskrivelseLoading] = useState(false);

    useEffect(() => {
        let isMounted = true;
        const fetchData = () => {
            if (isMounted) {
                setIsMentalbeskrivelseLoading(true);
            }
            getMentalbeskrivelse(hundId, id)
                .then((data) => {
                    if (isMounted) {
                        setMentalbeskrivelse(data);
                        setIsMentalbeskrivelseLoading(false);
                    }
                })
                .catch((err)=> {
                    if (isMounted) {
                        setIsMentalbeskrivelseLoading(false);
                        setMentalbeskrivelse(null);
                    }
                });
        };
        fetchData();
        return () => {
            isMounted = false;
        };
    }, [hundId, id]);
    return { mentalbeskrivelse, isMentalbeskrivelseLoading };
};


const useFetchAvkomRoentgenStatistikk = (hundId, id) => {
    const [avkomRoentgenStatistikk, setAvkomRoentgenStatistikk] = useState(null);
    const [isAvkomRoentgenStatistikkLoading, setIsAvkomRoentgenStatistikkLoading] = useState(false);

    useEffect(() => {
        let isMounted = true;
        const fetchData = () => {
            if (isMounted) {
                setIsAvkomRoentgenStatistikkLoading(true);
            }
            getAvkomRoentgenStatistikk(hundId, id)
                .then((data) => {
                    if (isMounted) {
                        setAvkomRoentgenStatistikk(data);
                        setIsAvkomRoentgenStatistikkLoading(false);
                    }
                })
                .catch((err)=> {
                    if (isMounted) {
                        setIsAvkomRoentgenStatistikkLoading(false);
                        setAvkomRoentgenStatistikk(null);
                    }
                });
        };
        fetchData();
        return () => {
            isMounted = false;
        };
    }, [hundId, id]);
    return { avkomRoentgenStatistikk, isAvkomRoentgenStatistikkLoading };
};

const useFetchBarnebarnRoentgenStatistikk = (hundId, id) => {
    const [barnebarnRoentgenStatistikk, setBarnebarnRoentgenStatistikk] = useState(null);
    const [isBarnebarnRoentgenStatistikkLoading, setIsBarnebarnRoentgenStatistikkLoading] = useState(false);

    useEffect(() => {
        let isMounted = true;
        const fetchData = () => {
            if (isMounted) {
                setIsBarnebarnRoentgenStatistikkLoading(true);
            }
            getBarnebarmRoentgenStatistikk(hundId, id)
                .then((data) => {
                    if (isMounted) {
                        setBarnebarnRoentgenStatistikk(data);
                        setIsBarnebarnRoentgenStatistikkLoading(false);
                    }
                })
                .catch((err)=> {
                    if (isMounted) {
                        setIsBarnebarnRoentgenStatistikkLoading(false);
                        setBarnebarnRoentgenStatistikk(null);
                    }
                });
        };
        fetchData();
        return () => {
            isMounted = false;
        };
    }, [hundId, id]);
    return { barnebarnRoentgenStatistikk, isBarnebarnRoentgenStatistikkLoading };

};

const useFetchRaseRoentgenStatistikk = (hundId, id) => {
    const [raseRoentgenStatistikk, setRaseRoentgenStatistikk] = useState(null);
    const [isRaseRoentgenStatistikkLoading, setIsRaseRoentgenStatistikkLoading] = useState(false);

    useEffect(() => {
        let isMounted = true;
        const fetchData = () => {
            if (isMounted) {
                setIsRaseRoentgenStatistikkLoading(true);
            }
            getRaseRoentgenStatistikk(hundId, id)
                .then((data) => {
                    if (isMounted) {
                        setRaseRoentgenStatistikk(data);
                        setIsRaseRoentgenStatistikkLoading(false);
                    }
                })
                .catch((err)=> {
                    if (isMounted) {
                        setIsRaseRoentgenStatistikkLoading(false);
                        setRaseRoentgenStatistikk(null);
                    }
                });
        };
        fetchData();
        return () => {
            isMounted = false;
        };
    }, [hundId, id]);
    return { raseRoentgenStatistikk, isRaseRoentgenStatistikkLoading };

};


export default withRouter(SunnhetAdferdStatistikkContainer);